import { SimulatePriceRequest } from 'features/simulation/types'
import { COUNTER_TYPES, EL_PRODUCT_CODES } from '@boltenergy-be/shared'

export const MIN_DISTANCE = 0
export const MAX_DISTANCE = 30_000
export const DEFAULT_DISTANCE = 15_000
export const AVERAGE_EV_CHARGING_USAGE = 16 // Average EV usage is 16 kWh per 100 km
export const EV_FLEX_ADVANTAGE = 150

export const EV_FLEX_SIMULATION_PRICE_REQUEST: Omit<SimulatePriceRequest, 'meterUsage'> = {
  deliveryPoint: {
    postalCode: '2000',
    townCode: '1',
    townName: 'Antwerpen'
  },
  counterType: COUNTER_TYPES.digital,
  hasSolarPanels: false,
  isCompany: false,
  product: {
    electricity: EL_PRODUCT_CODES.VariableOff
  }
}
